import React from 'react';
import { ToastProvider as ReactNotificationsToastProvider, } from 'react-toast-notifications';
import Toast from '../toast';
import ToastContainer from '../toast-container';
var ToastProvider = function (_a) {
    var children = _a.children, _b = _a.placement, placement = _b === void 0 ? 'top-center' : _b, _c = _a.autoDismissTimeout, autoDismissTimeout = _c === void 0 ? 3000 : _c;
    return (React.createElement(ReactNotificationsToastProvider, { components: { Toast: Toast, ToastContainer: ToastContainer }, placement: placement, autoDismissTimeout: autoDismissTimeout }, children));
};
export default ToastProvider;
